import React from 'react';
import * as logger from '@happyreturns/jscommons';
import PropTypes from 'prop-types';
import Icon from '../icons';
import { getColor } from '../utility';

function ContactBox(props) {
  return (
    <div
      className="contact-box infobox"
      onClick={() => {
        logger.Info("User clicked 'Contact Us' link");

        // open page specified by prop in a new tab
        window.open(props.contactURL, '_blank');
      }}
    >
      <div className="contact-box-text contact-text-gray">Have Questions?</div>
      <div
        className="contact-box-text contact-text-color"
        style={{ 'margin-left': 'auto' }}
      >
        Contact Us
      </div>
      <div className="linkarrow">
        <Icon
          fill={getColor('primary')}
          name="linkarrow"
          style={{ 'margin-left': '4px', 'margin-bottom': '2px' }}
        />
      </div>
    </div>
  );
}
ContactBox.propTypes = {
  // url to open when user clicks on contact box
  contactURL: PropTypes.string.isRequired,
};

export default ContactBox;
